/**
 * @class ComplementaryProducts
 * @classdesc The class for initializing complementary product recommendations
 *
 * @extends Core.Component
 */

 export default class ComplementaryProducts extends Core.Component {
  onMount() {
    this.loadRecommendations();
  }

  /**
   * Fetches and inserts section content via the Shopify recommendations endpoint
   */
  loadRecommendations() {
    const url = `${this.data.recommendations_route}?section_id=${this.data.section_id}&limit=${this.data.product_recommendation_limit}&product_id=${this.data.product_id}&intent=complementary`;
    return fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;

        this.el.querySelector('[data-complementary-products-content]').innerHTML = html.querySelector('[data-complementary-products-content]').innerHTML;
      });
  }
}
